<div class="group relative flex flex-col h-full 
       bg-white/[0.08] backdrop-blur-2xl rounded-2xl 
       border border-white/[0.15]
       shadow-[0_8px_32px_0_rgba(0,0,0,0.37)] 
       overflow-hidden transition-all duration-500
       hover:bg-white/[0.12] 
       hover:border-primary/60
       hover:-translate-y-1
       hover:shadow-[0_20px_40px_rgba(0,0,0,0.5),0_0_20px_rgba(var(--primary),0.1)]">

    <!-- IMAGE -->
    <div class="aspect-video w-full overflow-hidden bg-black relative group">

        <ng-container *ngIf="project.imageUrl; else placeholder">
            <img [src]="project.imageUrl" class="absolute inset-0 w-full h-full object-cover blur-xl opacity-80 scale-110 transition-opacity duration-500 group-hover:opacity-20" />

            <img [src]="project.imageUrl" [alt]="project.title" class="relative w-full h-full object-contain z-10 transform group-hover:scale-105 transition-transform duration-650" />
        </ng-container>

        <div class="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent opacity-60 z-20 pointer-events-none"></div>

        <ng-template #placeholder></ng-template>
    </div>

    <!-- CONTENT -->
    <div class="flex-1 p-6 flex flex-col">
        <div class="flex items-start justify-between mb-4">

            <a [routerLink]="['/projects', project.slug]" class="cursor-pointer">
                <h3 class="font-display text-xl font-bold
                 group-hover:text-primary transition-colors">
                    {{ project.title }}
                </h3>
            </a>

            <!-- LINKS -->
            <div class="flex gap-2">
                <a *ngIf="project.githubUrl" [href]="project.githubUrl" target="_blank" rel="noreferrer" class="text-muted-foreground hover:text-primary transition-colors">
                    <!-- GitHub icon -->
                    <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 .5C5.73.5.5 5.74.5 12.02c0 5.11 3.29 9.45 7.86 10.98.57.1.78-.25.78-.55v-2.1c-3.2.7-3.88-1.55-3.88-1.55-.53-1.34-1.3-1.7-1.3-1.7-1.06-.73.08-.72.08-.72 1.17.08 1.79 1.21 1.79 1.21 1.04 1.79 2.74 1.27 3.41.97.1-.75.41-1.27.74-1.56-2.55-.29-5.23-1.28-5.23-5.69 0-1.26.45-2.29 1.19-3.1-.12-.3-.52-1.5.11-3.13 0 0 .97-.31 3.18 1.18.92-.26 1.9-.38 2.88-.38.98 0 1.96.13 2.88.38 2.2-1.5 3.18-1.18 3.18-1.18.63 1.63.23 2.83.11 3.13.74.81 1.19 1.84 1.19 3.1 0 4.42-2.69 5.39-5.25 5.67.42.36.79 1.07.79 2.16v3.2c0 .3.21.66.79.55A11.52 11.52 0 0023.5 12C23.5 5.74 18.27.5 12 .5z" />
                    </svg>
                </a>

                <a *ngIf="project.demoUrl" [href]="project.demoUrl" target="_blank" rel="noreferrer" class="text-muted-foreground hover:text-primary transition-colors">
                    <!-- External link icon -->
                    <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                        <polyline points="15 3 21 3 21 9" />
                        <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                </a>
            </div>
        </div>

        <p class="text-muted-foreground line-clamp-3 mb-6 flex-1
             text-sm leading-relaxed">
            {{ project.summary }}
        </p>

        <!-- TAGS -->
        <div class="flex flex-wrap gap-2 mt-auto">
            <app-badge *ngFor="let tag of visibleTags" variant="secondary" class="bg-secondary/50 hover:bg-secondary text-xs">
                {{ tag }}
            </app-badge>

            <app-badge *ngIf="extraTagCount > 0" variant="outline" class="text-xs">
                +{{ extraTagCount }}
            </app-badge>
        </div>

        <a [routerLink]="['/projects', project.slug]" class="mt-6 flex items-center gap-2 text-sm font-medium
             text-primary hover:text-primary/80 transition-colors
             group/link">
            View Details
            <svg class="w-4 h-4 transform group-hover/link:translate-x-1 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
            </svg>
        </a>
    </div>
</div>